"use client"
import { createContext, useContext, useState } from "react"
import type { ReactNode } from "react"

type PromotionBannerContextType = {
  pageSpecificBanner: any | null
  hideAllSitewide: boolean
  setPageBannerOverride: (banner: any | null, hideAll?: boolean) => void
  clearPageBannerOverride: () => void
}

export const PromotionBannerContext = createContext<PromotionBannerContextType>(
  {
    pageSpecificBanner: null,
    hideAllSitewide: false,
    setPageBannerOverride: () => {},
    clearPageBannerOverride: () => {},
  },
)

export function PromotionBannerProvider({ children }: { children: ReactNode }) {
  const [pageSpecificBanner, setPageSpecificBanner] = useState<any | null>(null)
  const [hideAllSitewide, setHideAllSitewide] = useState(false)

  const setPageBannerOverride = (banner: any | null, hideAll = false) => {
    setPageSpecificBanner(banner)
    setHideAllSitewide(hideAll)
  }

  const clearPageBannerOverride = () => {
    setPageSpecificBanner(null)
    setHideAllSitewide(false)
  }

  return (
    <PromotionBannerContext.Provider
      value={{
        pageSpecificBanner,
        hideAllSitewide,
        setPageBannerOverride,
        clearPageBannerOverride,
      }}
    >
      {children}
    </PromotionBannerContext.Provider>
  )
}

export function usePromotionBanner() {
  return useContext(PromotionBannerContext)
}
